import { Layers } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Bốn quy tắc của MRP — anh Toàn chốt 19/09/2026 theo chuẩn (MRP-R01..R03 + phạm vi chạy), khách bác lại được. Trước đây là ba thẻ vàng
 * "chờ khách xác nhận" trên cả trang tính và trang kịch bản; nay là một mục gập trung tính.
 */
export const MRP_RULES = ["scope", "netting", "timing", "authority"] as const;

export function MrpRules() {
  return <SettledRules ns="mrp" rules={MRP_RULES} icon={Layers} />;
}

/** Cùng bộ giải quyền với máy chủ — chỉ để khỏi vẽ nút mà bấm vào là 403. Lập yêu cầu mua cần ô Tạo ở CẢ MRP và Yêu cầu mua hàng. */
export function useMrpAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (menu: "mrp" | "requisitions", verb: AccessVerb) => !!access && canAccess(access, menu, verb);
}
